const AMPLAR_CONTENT_BASE_URL =
  import.meta.env.VITE_AMPLAR_CONTENT_BASE_URL ?? '';
const MY_HEALTH_CONTENT_BASE_URL =
  import.meta.env.VITE_MY_HEALTH_CONTENT_BASE_URL ?? '';

export const AMPLAR_EXTERNAL_LINKS = {
  TERMS: AMPLAR_CONTENT_BASE_URL
    ? `${AMPLAR_CONTENT_BASE_URL}/terms-and-conditions`
    : '',
  PRIVACY: AMPLAR_CONTENT_BASE_URL
    ? `${AMPLAR_CONTENT_BASE_URL}/privacy-collection-notice`
    : '',
  FAQ: '', // TODO: replace with real FAQ URL once available
};

export const MY_HEALTH_EXTERNAL_LINKS = {
  TERMS: MY_HEALTH_CONTENT_BASE_URL
    ? `${MY_HEALTH_CONTENT_BASE_URL}/terms-and-conditions`
    : '',
  PRIVACY: MY_HEALTH_CONTENT_BASE_URL
    ? `${MY_HEALTH_CONTENT_BASE_URL}/privacy-collection-notice`
    : '',
  FAQ: '', // TODO: replace with real FAQ URL once available
};

export const EXTERNAL_LINKS = {
  DISCLAIMER: 'https://onlinedoctor.amplarhealth.com.au/',
  APPLE_STORE_APP: 'https://apple.com',
  GOOGLE_PLAY_STORE_APP: 'https://google.com',
};
